var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgBsc = function SvgBsc(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#1D1D1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16193 12L6.58295 13.579L5 12L6.57898 10.421L8.16193 12ZM12 8.16193L14.7085 10.8705L16.2875 9.29148L12 5L7.70852 9.29148L9.2875 10.8705L12 8.16193ZM17.417 10.421L15.8381 12L17.417 13.579L18.996 12L17.417 10.421ZM12 15.8381L9.29148 13.1295L7.7125 14.7085L12 19L16.2875 14.7085L14.7085 13.1295L12 15.8381ZM12 13.579L13.579 12L12 10.421L10.417 12L12 13.579Z",
    fill: "#F0B90B"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgBsc);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,IDxzdmcgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMiIgZmlsbD0iIzFEMUQxRCIvPgogICAgPHBhdGggZD0iTTguMTYxOTMgMTJMNi41ODI5NSAxMy41NzlMNSAxMkw2LjU3ODk4IDEwLjQyMUw4LjE2MTkzIDEyWk0xMiA4LjE2MTkzTDE0LjcwODUgMTAuODcwNUwxNi4yODc1IDkuMjkxNDhMMTIgNUw3LjcwODUyIDkuMjkxNDhMOS4yODc1IDEwLjg3MDVMMTIgOC4xNjE5M1pNMTcuNDE3IDEwLjQyMUwxNS44MzgxIDEyTDE3LjQxNyAxMy41NzlMMTguOTk2IDEyTDE3LjQxNyAxMC40MjFaTTEyIDE1LjgzODFMOS4yOTE0OCAxMy4xMjk1TDcuNzEyNSAxNC43MDg1TDEyIDE5TDE2LjI4NzUgMTQuNzA4NUwxNC43MDg1IDEzLjEyOTVMMTIgMTUuODM4MVpNMTIgMTMuNTc5TDEzLjU3OSAxMkwxMiAxMC40MjFMMTAuNDE3IDEyTDEyIDEzLjU3OVoiIGZpbGw9IiNGMEI5MEIiLz4KICAgIDwvc3ZnPg==";